<template>
  <div class="home-service">
        <div class="wrap">
        <UiHeading
          :h="'2'"
          :type="'E'"
          :text="'Recruit'"
          :subTitle="'求人・採用'"
        />

        <p class="des">株式会社R.C.I.は、一緒にお仕事をする仲間を募集しています。年間を通して、既存の事業を育てながら、新規事業を1～2つのペースで立ち上げる成長中の企業です。そのため、責任あるポジションでの仕事を通して、キャリアアップを目指すことができます。</p>

<div class="kenko-keiei">
  <img src="@/assets/kenko-keiei.jpeg" alt="健康経営優良法人2026 中小規模法人部門" class="kenko-keiei__image">
  <p class="kenko-keiei__text">株式会社R.C.I.は<br class="sp-only">健康経営優良法人に認定されました</p>
</div>

<div class="recruit-site-btn-wrap">
  <a href="https://robe-international.com/recruit/" target="_blank" rel="noopener noreferrer" class="recruit-site-btn">
    <div class="basicBox">
      R.C.I. の求人サイトを見る
      <svg width="320" height="48" viewBox="0 0 320 48" xmlns="http://www.w3.org/2000/svg">
        <rect x="0" y="0" width="320" height="48" />
      </svg>
    </div>
  </a>
</div>

       </div>
<h4 class="toiawase">お問い合わせは、お電話、または、お問い合わせフォームからお願いいたします。</h4>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UiHeading from "@/components/Ui/Heading.vue";

export default {
  name: "HomeService",
  components: {
    UiHeading,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.des{
  padding: 50px 0;
}
.box-cover{
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
.box{
  width: 48%;
  margin-bottom: 30px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
}
.toiawase{
  background-color: var(--main);
  color: white;
  text-align: center;
  padding: 30px 0;
  margin-top: 50px;
  @media screen and (max-width: 1100px) {
padding-right: 20px;
padding-left: 20px;
  }
}
.kenko-keiei{
  margin-top: 20px;
  text-align: center;
  &__text{
    font-weight: bold;
    margin-bottom: 20px!important;
  }
  &__image{
    max-width: 400px;
    width: 100%;
    height: auto;
  }
}

.recruit-site-btn-wrap{
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
}
.recruit-site-btn{
  display: inline-block;
  text-decoration: none;

  .basicBox{
    position: relative;
    width: 320px;
    max-width: 100%;
    height: 48px;
    margin: 0 auto;
    color: var(--main);
    font-size: 1.1rem;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
    transition: color 0.4s ease-in-out;

    @media screen and (max-width: 768px) {
      width: 280px;
      font-size: 1rem;
    }
  }
  .basicBox:hover{
    color: var(--sub);
  }

  svg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  svg rect{
    fill: none;
    stroke: var(--main);
    stroke-width: 1;
    stroke-dasharray: 736, 0;
    transition: all 0.8s ease-in-out;
  }
  .basicBox:hover svg rect{
    stroke: var(--sub);
    stroke-width: 3;
    stroke-dasharray: 38, 700;
    stroke-dashoffset: 38;
    transition: all 0.8s ease-in-out;
  }
}

</style>
